export const MAX_HOURS = 24;

export interface IHoursParseResult {
	hours?: number;
	error?: string;
}

export function parseHoursInput(raw: string): IHoursParseResult {
	const trimmed = raw.trim();
	if (!trimmed) {
		return { error: "Enter the day's hours." };
	}
	if (!/^\d+(\.\d+)?$/.test(trimmed)) {
		return { error: 'Enter hours as a number, such as 8 or 7.75.' };
	}
	const hours = Number(trimmed);
	if (hours < 0 || hours > MAX_HOURS) {
		return { error: 'Hours must be between 0 and 24.' };
	}
	if (!Number.isInteger(hours * 4)) {
		return { error: 'Hours must be in quarter hours, such as 8, 8.25, 8.5 or 8.75.' };
	}
	return { hours };
}

export function formatHours(hours?: number) {
	return hours === undefined ? '—' : hours.toFixed(2);
}
